export default __webpack_public_path__ + "static/media/move_normal.82aa6e48.mp3";